<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col>
              <h1>
                <feather-icon icon="ListIcon" size="30" class="mr-50" /> Avaliar
                Desafios
              </h1>
              <h4 class="mt-1">Selecione um desafio para avaliar:</h4>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col md="4">
        <b-form-group label="Escola" label-for="schoolFilter">
          <b-form-select
            id="schoolFilter"
            v-model="selectedSchool"
            :options="schoolOptions"
            @change="fetchData"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Desafio" label-for="challengeFilter">
          <b-form-select
            id="challengeFilter"
            v-model="selectedChallenge"
            :options="challengeOptions"
            @change="filterList"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Período" label-for="dateFilter">
          <b-form-select
            id="dateFilter"
            v-model="selectedPeriod"
            :options="periodOptions"
            @change="onPeriodChange"
          />
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="showDatePicker">
        <b-form-group label="Data inicial" label-for="dataInicio">
          <b-form-input
            id="dataInicio"
            v-model="customDataInicio"
            type="date"
            @change="fetchData"
          />
        </b-form-group>
      </b-col>
      <b-col md="4" v-if="showDatePicker">
        <b-form-group label="Data final" label-for="dataFim">
          <b-form-input
            id="dataFim"
            v-model="customDataFim"
            type="date"
            @change="fetchData"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>
          <b-form-input placeholder="Pesquisar por aluno" @keydown.enter="filterList" v-model="searchQuery"/>
        </b-input-group>
      </b-col>
    </b-row>

    <div class="mb-2 mt-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-nowrap">
              Mostrando {{ tableItems.length }} de {{ totalItems }} registros
            </span>
          </b-col>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination v-model="currentPage" :total-rows="totalItems" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    <b-card no-body class="mb-0">
      <b-table
        ref="refUserListTable"
        style="min-height: 50vw"
        class="position-relative"
        :items="tableItems"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :per-page="perPage"
        :current-page="currentPage"
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolverStatusVariant(data.item.approved, data.item.feedback)}`"
            class="text-capitalize"
          >
            {{ resolveUserStatusText(data.item.approved, data.item.feedback) }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- <b-dropdown-item
              :to="{ name: 'pacienteEdit', params: { id: data.item.id } }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item> -->
            <!--Mostrar apenas se tiver alguma consulta marcada -->

            <b-dropdown-item
              :to="{
                name: obterUrlAvaliar(data.item.modelo),
                params: { id: data.item.id },
              }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Avaliar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>
    <div class="mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-nowrap">
              Mostrando {{ tableItems.length }} de {{ totalItems }} registros
            </span>
          </b-col>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination v-model="currentPage" :total-rows="totalItems" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BDropdown,
  BDropdownItem,
  BBadge,
  BCol,
  BRow,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BPagination,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import challengeService from '@/services/challengeService'
import schoolService from '@/services/schoolService'
import { hideSpinner, showSpinner } from '@/services/spinService'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BBadge,
    BCol,
    BRow,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BPagination,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  methods: {
    // resolveUserRoleVariant: role => {
    //   if (role === 'paciente') return 'primary'
    //   if (role === 'author') return 'warning'
    //   if (role === 'maintainer') return 'success'
    //   if (role === 'editor') return 'info'
    //   if (role === 'admin') return 'danger'
    //   return 'primary'
    // },
    // resolveUserRoleIcon: role => {
    //   if (role === 'paciente') return 'UserIcon'
    //   if (role === 'author') return 'SettingsIcon'
    //   if (role === 'maintainer') return 'DatabaseIcon'
    //   if (role === 'editor') return 'Edit2Icon'
    //   if (role === 'admin') return 'ServerIcon'
    //   return 'UserIcon'
    // },
    resolveUserStatusText: (status, feedback) => {
      if (status === true) return 'aprovado'
      if (feedback) return 'Com feedback'
      if (status === false) return 'Não Aprovado'
      return ''
    },

    resolverStatusVariant: (status, feedback) => {
      if (status === true || feedback) return 'success'
      if (status === false) return 'warning'
      if (status === 'alta') return 'primary'
      if (status === 'óbito') return 'danger'
      return 'primary'
    },
    async fetchData() {
      showSpinner()
      const filter = {}
      if (this.selectedSchool) {
        filter.schoolId = this.selectedSchool
      }
      if (this.selectedPeriod === 'hoje') {
        const hoje = new Date()
        filter.dataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()).toISOString()
        filter.dataFim = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate(), 23, 59, 59).toISOString()
      } else if (this.selectedPeriod === 'semana') {
        const hoje = new Date()
        const inicioSemana = new Date(hoje)
        inicioSemana.setDate(hoje.getDate() - hoje.getDay())
        const fimSemana = new Date(inicioSemana)
        fimSemana.setDate(inicioSemana.getDate() + 6)
        filter.dataInicio = new Date(inicioSemana.getFullYear(), inicioSemana.getMonth(), inicioSemana.getDate()).toISOString()
        filter.dataFim = new Date(fimSemana.getFullYear(), fimSemana.getMonth(), fimSemana.getDate(), 23, 59, 59).toISOString()
      } else if (this.selectedPeriod === 'selecionar' && this.customDataInicio && this.customDataFim) {
        filter.dataInicio = new Date(this.customDataInicio).toISOString()
        filter.dataFim = new Date(this.customDataFim + 'T23:59:59').toISOString()
      }
      const items = await challengeService.getForReview(filter)
      this.allItems = items
      this.tableItems = items
      this.totalItems = items.length
      this.updateChallengeOptions()
      hideSpinner()
    },
    onPeriodChange() {
      this.showDatePicker = this.selectedPeriod === 'selecionar'
      this.fetchData()
    },
    updateChallengeOptions() {
      const uniqueChallenges = [...new Set(this.allItems.map(item => item.modelo).filter(Boolean))]
      this.challengeOptions = [
        { value: null, text: 'Todos os desafios' },
        ...uniqueChallenges.map(modelo => ({
          value: modelo,
          text: modelo
        }))
      ]
    },
    async loadSchools() {
      try {
        const response = await schoolService.getAll({})
        this.schoolOptions = [
          { value: null, text: 'Todas as escolas' },
          ...response.content.map(school => ({
            value: school.id,
            text: school.name
          }))
        ]
      } catch (error) {
        console.error('Erro ao buscar escolas:', error)
      }
    },
    filterList() {
      let filtered = this.allItems

      const query = this.searchQuery.toLowerCase()
      if (query) {
        filtered = filtered.filter(item =>
          (item.titulo || '').toLowerCase().includes(query) ||
          (item.modelo || '').toLowerCase().includes(query) ||
          (item.aluno || '').toLowerCase().includes(query) ||
          (item.turmaDescricao || '').toLowerCase().includes(query),
        )
      }

      if (this.selectedChallenge) {
        filtered = filtered.filter(item => item.modelo === this.selectedChallenge)
      }

      this.tableItems = filtered
      this.totalItems = this.tableItems.length
      this.currentPage = 1
    },
    obterUrlAvaliar(modelo) {
      if (modelo === 'Arboturma') return 'avaliarArboturma'
      if (modelo === 'Janelas e Tanques') return 'avaliarJanelaTanque'
      if (modelo === 'Patrulha em Foco') return 'avaliarPatrulha'
      if (modelo === 'Coleta e Reciclagem') return 'avaliarColeta'
      return ''
    },
  },
  data: () => ({
    tableItems: [],
    allItems: [],
    perPage: 10,
    totalItems: 0,
    currentPage: 1,
    perPageOptions: [10, 25, 50, 100],
    searchQuery: '',
    selectedSchool: null,
    schoolOptions: [
      { value: null, text: 'Todas as escolas' }
    ],
    selectedChallenge: null,
    challengeOptions: [
      { value: null, text: 'Todos os desafios' }
    ],
    selectedPeriod: null,
    periodOptions: [
      { value: null, text: 'Todos' },
      { value: 'hoje', text: 'Hoje' },
      { value: 'semana', text: 'Essa Semana' },
      { value: 'selecionar', text: 'Selecione' },
    ],
    showDatePicker: false,
    customDataInicio: '',
    customDataFim: '',
    sortBy: 'id',
    isSortDirDesc: true,
    roleFilter: null,
    planFilter: null,
    statusFilter: null,
    tableColumns: [
      { key: 'titulo', label: 'Nome', sortable: true },
      { key: 'modelo', label: 'Modelo', sortable: true },
      { key: 'aluno', label: 'Aluno(s)', sortable: true },
      { key: 'turmaDescricao', label: 'Turma', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      // { key: 'Tipo', label: 'Tipo', sortable: true },
      // { key: 'Duracao', label: 'Duração', sortable: true },
      // { key: 'Instituição', label: 'Instituição', sortable: true },
      // { key: 'Autor', label: 'Autor', sortable: true },
      // { key: 'status', sortable: true },
      { key: 'actions', label: 'Ações', sortable: false },
    ],
  }),
  mounted() {
    this.loadSchools()
    this.fetchData()
  },
}
</script>
